'use strict';

var _ = require('lodash');

exports.strictnessOrder = ['Full Refund', 'Partial Refund', 'No Refund', 'Penalty'];

exports.positives = ['Full Refund', 'Partial Refund'];

var refundTypes = {};
_.each(exports.strictnessOrder, function (type) {
  refundTypes[type] = type;
});

exports.types = refundTypes;

var refundQuantities = ['PERCENT_OF_DEPOSIT', 'PERCENT_OF_EVENT_TOTAL', 'DOLLARS', 'PERCENT_OF_THE_BALANCE_OF_THE_EVENT'];

exports.refundQuantities = {};
_.each(refundQuantities, function (refund) {
  exports.refundQuantities[refund] = _.startCase(refund).toLowerCase();
});

exports.multipliers = {
  'PERCENT_OF_DEPOSIT': 'the deposit',
  'PERCENT_OF_EVENT_TOTAL': 'the event total',
  'DOLLARS': 'dollars',
  'PERCENT_OF_THE_BALANCE_OF_THE_EVENT': 'the balance of the event'
};